export enum AuditionType {
  StudioSession = 'studio',
  SelfTapes = 'self_tapes',
}
